<template>
  <section id="mainContainer">
      <userHeader></userHeader> 
      <section class="mid-container">
              <section class="career-details-page">
                <div class="career-details-banner">
                <div class="container">
                  <h1>{{ jobInfoData.jobTitle }}</h1>
                </div>
                </div>
                <div class="career-details-inner">
              <div class="container">
                <div class="career-details-sidebar">
                    <div class="career-right-img">
                        <img :src="getCdnImageAddress(jobInfoData.jobImage, `w_250,h_140/`)" />
                    </div>
                    <h4>{{ jobInfoData.jobTitle }}</h4>
                    <div class="job-detail-rigth">
                        <ul>
                            <li><i><img src="@/assets/images/map-marker-alt.svg" /></i> {{ jobInfoData.location }}</li>
                            <li><i><img src="@/assets/images/clock.svg" /></i> {{jobInfoData.requiredExperience.from}}+ years</li>
                        </ul>
                    </div>
                    <div class="job-short-des">
                        <p v-html="jobInfoData.shortDescription"></p>
                    </div>
                    <div class="apply-btn">
                        <button data-bs-toggle="modal" data-bs-target="#joinUs" class="primary-btn-outline">Apply Now</button>
                    </div>
                </div>
                <div class="career-details-content">
                  <div class="job_des">
                    <h3>Job Description</h3>
                    <p v-html="jobInfoData.jobDescription"></p>
                  </div>
                  <div class="job_des">
                    <h3>JOB REQUIREMENTS</h3>
                    <p v-html="jobInfoData.jobRequirements"></p>
                  </div>
                  <div class="job_des">
                      <h3>KEY RESPONSIBILITIES ACTIVITIES</h3>
                    <p v-html="jobInfoData.keyAndResponsibilities"></p>
                    </div>
                    <div class="job_des">
                      <h3>BENEFITS</h3>
                      <p v-html="jobInfoData.benefits"></p>
                    </div>
                    <div class="apply-btn">
                      <button data-bs-toggle="modal" data-bs-target="#joinUs" class="primary-btn-outline">Apply Now</button>
                  </div>
                </div>
                <div class="clear"></div>
              </div>
                </div>
              </section>
          </section>
<!-- Modal -->
<jobForm></jobForm>
    <userFooter></userFooter>
  </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import userHeader from "@/components/userHeader.vue";
import axios from 'axios';
import { useRoute } from 'vue-router';
import userFooter from "@/components/userFooter.vue";
import jobForm from "@/components/jobForm.vue";
import { environment } from '@/config/environment';
import { API_BASE_URL } from '@/config/api.config';


export default defineComponent({
name: "readMoreAboutJob",
components: {
  userHeader,
  userFooter,
  jobForm
},
data() {
  return {
    jobInfoId: '',
    jobInfoData:{
      jobTitle: '',
      jobDescription: '',
      shortDescription: '',
      benefits: '',
      keyAndResponsibilities: '',
      jobRequirements: '',
      location: '',
      requiredExperience: {
        from: '',
        to: '',
      },
      jobImage: '',
    }
     
  };
},
methods: {
  async fetchJobInfoData() {
    try {
      const response = await axios.get(`${API_BASE_URL}/job/${this.jobInfoId}/`);
      this.jobInfoData = response.data; 
    } catch (err) {
      console.error(err);
    }
  },
  getCdnImageAddress(src: string, size: string): string {
    if (!src) return '';
    let cdnUrl: string = environment.imageCdn.getHost;
    cdnUrl = cdnUrl.concat(size);
    return cdnUrl + encodeURIComponent(src);
  }
},
mounted() {
  const route = useRoute();
  this.jobInfoId = route.params.slug  as string; 
  if (this.jobInfoId) {
    this.fetchJobInfoData();
  } else {
      console.error(Error);
  }
}
});
</script>